const o = {
  "chip--hover-actions": "_chip--hover-actions_45blb_20",
  "chip--hover-action": "_chip--hover-action_45blb_20"
};
export {
  o as default
};
//# sourceMappingURL=index.es5597.js.map
